import { render, staticRenderFns } from "./EventInfoModal.vue?vue&type=template&id=f512c6a8&scoped=true&lang=html&"
import script from "./EventInfoModal.vue?vue&type=script&lang=js&"
export * from "./EventInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512c6a8",
  null
  
)

export default component.exports